import Axios from "axios";
import config from '../../config'
const NAME = "Approval"

export default {
  namespaced: true,
  state: {
    data: null,
    isFetching: false,
    errorMessage: null,
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data
    },
    SET_IS_FETCHING(state, value) {
      state.isFetching = value
    },
    SET_ERROR(state, error) {
      state.errorMessage = error
    },
  },
  actions: {
    fetchAnnouncement({ commit }) {
      commit("SET_IS_FETCHING", true)
      Axios.get(`${config.webprofileUrl}/title/${NAME}`)
        .then(response => {
          commit("SET_DATA", response.data)
        })
        .catch(error => {
          commit("SET_ERROR", error)
        })
        .finally(() => {
          commit("SET_IS_FETCHING", false)
        })
    }
  },
  getters: {
    getData(state) {
      return state.data
    }
  }
};
